import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { togglePaymentModal } from '../../Modal/actions';


@translate(['dashboard'], { wait: true })
@connect(
  state => ({
    hasNewBills: state.bills.hasNewBills,
  }),
  dispatch => ({
    toggleModal() {
      return dispatch(togglePaymentModal());
    },
  }),
)
export class NewBill extends Component {
  toggleModal = (e) => {
    e.preventDefault();

    this.props.toggleModal();
  };

  render() {
    const { t } = this.props;
    return (
      this.props.hasNewBills &&
      <a className="btn-add-funds" onClick={this.toggleModal} href="">
        {t('dashboard:payment_notification')}
        <span className="more">
          {t('add_funds')} <i className="icon-arrow-right" />
        </span>
      </a>
    );
  }
}

NewBill.WrappedComponent.propTypes = {
  hasNewBills: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  toggleModal: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Dashboard/Bills/NewBill.js